<template>
  <p-select
    :model.sync="model"
    @on-change="onChange"
    :rules="rules"
    :multiple="multiple"
    :filterable="filterable"
    :clearable="clearable"
    :disabled="disabled"
    :placeholder="placeholder"
    :size="size"
    :placement="placement"
    :render-format="renderFormat"
  >
    <p-option
      :value="it.orgUnitId"
      :label="it.orgUnitName"
      v-for="it in list"
      track-by="$index"
      :disabled="!canSelect(it)"
    >{{{it.vmOrgUnitName}}}</p-option>
  </p-select>
</template>

<script>
import { getJSON } from "../common/utils";
export default {
  name: "OrgCheck",
  props: {
    model: {
      type: [String, Number, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    debug: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterByPin: {
      type: Boolean,
      default: true
    },
    disabledVirtual: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    size:  {
      type: String
    },
    type:  {
      type: String
    },
    resourceCode:  {
      type: String,
      default:''
    },
    rules: {
      type: Array
    },
    placement: {
      type: String
    },
  },
  data() {
    return {
      list: [],
      value: []
    };
  },
  ready() {
    let d = getJSON(
      this.debug
        ? "/assets/org.json"
        : `//org.7fresh.com/org/api/bizOrgUnitTree/${this.type}/${this.resourceCode}`,
      "GET"
    );
    d.done(data => {
      data.vmOrgUnitName=data.orgUnitName;
      this.list.push(data);
      this.initData(data.childList);
      console.log(data.childList)
    });
  },
  methods: {
    canSelect(it){
      return this.filterByPin?it.canSelect:it.orgUnitFunction==1
    },
    initData(childList, spaceCount) {
      spaceCount = spaceCount || 1;
      for (let it of childList) {
        let space = [];
        for (let i = 0; i < spaceCount; i++) {
          space.push("&#12288;");
        }
        it.vmOrgUnitName = space.join("")+it.orgUnitName;
        this.list.push(it);
        if (it.childList && it.childList.length) {
          this.initData(it.childList, spaceCount+1);
        }
      }
    },
    onChange(value) {
      // debugger;
      let val;
      if(this.multiple){
        val=[];
        for(let v of value){
          let item=this.list.find(it=>it.orgUnitId==v);
          if(item){
            let {orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId}=item;  
            val.push({orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId});
          }
        }
        this.$emit('on-change',val,value);
      }else{
        val=this.list.find(it=>it.orgUnitId==value);
        let tmp=null;
        if(val){
          let {orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId}=val;
          tmp={orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId};
        }
        this.$emit('on-change',tmp,value);
      }
      // if(val&&val.length){
      //   let tmp=[];
      //   debugger;
      //   for(let it of val){
      //     let {orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId}=it;  
      //     tmp.push({orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId});
      //   }
      //   this.$emit('on-change',tmp,value);
      // }else{
      //   let {orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId}=val;
      //   debugger;

      //   this.$emit('on-change',{orgType,orgUnitFunction,orgUnitId,orgUnitName,parentOrgUnitId},value);
      // }
    },
    renderFormat(selected){
      return selected.map((it)=>{
        let {label}=it;
        if(label.includes('<')){
          it.label=it.label.substr(0,label.indexOf('<')) 
        }
        it.label=it.label.trim();
        return it;
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// org-check.vue?847ab744